/**
 * Payment Methods Duck
 *
 * Note: Sonispark uses a credits-based system, not real money payments.
 * This duck is preserved for compatibility but Stripe integration has been removed.
 * Credits are managed through the Sharetribe backend, not through Stripe.
 */

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/paymentMethods/SET_INITIAL_VALUES';

// ================ Reducer ================ //

const initialState = {};

export default function paymentMethodsReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: initialValues || {},
});
